// About.js
import React from 'react';
import { useScrollAnimation } from '../animations/ScrollAnimation';

const About = () => {
  useScrollAnimation();
  
  return (
    <section id="about" className="section about-section">
      <div className="container">
        <div className="about-grid">
          <div className="about-image appear">
            <div className="image-container">
              <div className="profile-image"></div>
            </div>
          </div>
          <div className="about-content">
            <h2 className="section-title appear">關於我</h2>
            
            <div className="motto-container appear">
              <div className="motto-animation-container">
                <p className="motto">「工具雖小，卻能一再解決問題。」</p>
              </div>
            </div>
            
            {/* 基本介紹 */}
            <div className="about-text appear">
              <p>嗨，我叫林昱弦，現在還是一位大學生。</p>
            </div>
            
            {/* 學歷 */}
            <div className="education appear">
              <h3>學歷</h3>
              <div className="timeline">
                <div className="timeline-item">
                  <div className="timeline-dot"></div>
                  <div className="timeline-content">
                    <h4>輔仁大學 － 統計資訊學系（主修）</h4>
                    <p>2020 - 至今</p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-dot"></div>
                  <div className="timeline-content">
                    <h4>輔仁大學 － 資訊工程學系（輔系）</h4>
                    <p>2020 - 至今</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* 經歷 */} 
            <div className="experience appear">
              <h3>經歷</h3>
              <div className="timeline">
                <div className="timeline-item">
                  <div className="timeline-dot"></div>
                  <div className="timeline-content">
                    <h4>輔仁大學－Chat輔U</h4>
                    <p>2024</p>
                    <p>後台管理系統開發、UI/UX、RWD</p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-dot"></div>
                  <div className="timeline-content">
                    <h4>輔仁大學－Chat輔U 2.0</h4>
                    <p>2025</p>
                    <p>組長</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* 技能 */}
            <div className="skills appear">
              <h3>專業技能</h3>
              <div className="skill-tags">
                <span className="skill-tag">UI/UX</span>
                <span className="skill-tag">Python</span>
                <span className="skill-tag">HTML</span>
                <span className="skill-tag">CSS</span>
                <span className="skill-tag">Javascript</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;